// import {
//   Modal,
//   ModalOverlay,
//   ModalContent,
//   ModalHeader,
//   ModalBody,
//   ModalFooter,
//   Button,
//   Select,
//   SimpleGrid,
//   Textarea,
//   VStack,
//   Box,
//   Text,
//   Input,
//   useToast,
//   Flex,
//   HStack,
//   Image,
//   AspectRatio,
//   Badge,
// } from "@chakra-ui/react";

// import { useEffect, useRef, useState } from "react";
// import axios from "axios";
// import { FiCamera, FiImage, FiUpload, FiX } from "react-icons/fi";

// import { LiderancaService } from "../../services/lideranca.service";
// import { ZonaService } from "../../services/zona.service";
// import { SessaoService } from "../../services/sessao.service";

// import { formatCPF, formatCEP, formatTitulo } from "./utils";

// interface Props {
//   isOpen: boolean;
//   onClose: () => void;
//   onSave: (data: any, imageFile?: File | null) => Promise<boolean>;
//   initialData?: any;
// }

// const initialForm = {
//   nome: "",
//   cpf: "",
//   rg: "",
//   titulo: "",
//   ano: "2026",
//   data_nascimento: "",
//   nome_mae: "",
//   contato: "",

//   cep: "",
//   endereco: "",
//   numero: "",
//   bairro: "",
//   cidade: "",
//   uf: "",

//   observacao: "",
//   image_path: "",

//   lideranca_id: "",
//   zona_id: "",
//   sessao_id: "",
// };

// function Section({ title, children }: { title: string; children: React.ReactNode }) {
//   return (
//     <Box
//       bg="white"
//       borderRadius="16px"
//       border="1px solid"
//       borderColor="gray.200"
//       overflow="hidden"
//       boxShadow="sm"
//     >
//       <Box px={5} py={3} bg="gray.50" borderBottom="1px solid" borderColor="gray.200">
//         <Text fontSize="md" fontWeight="700" color="gray.700">
//           {title}
//         </Text>
//       </Box>
//       <Box p={5}>{children}</Box>
//     </Box>
//   );
// }

// // Validações
// function validarCPF(cpf: string): boolean {
//   const cleaned = cpf.replace(/\D/g, "");
//   if (cleaned.length !== 11) return false;
//   // Algoritmo CPF (simplificado)
//   let sum = 0, rest;
//   for (let i = 1; i <= 9; i++) sum += parseInt(cleaned[i - 1]) * (11 - i);
//   rest = (sum * 10) % 11;
//   if (rest === 10 || rest === 11) rest = 0;
//   if (rest !== parseInt(cleaned[9])) return false;

//   sum = 0;
//   for (let i = 1; i <= 10; i++) sum += parseInt(cleaned[i - 1]) * (12 - i);
//   rest = (sum * 10) % 11;
//   if (rest === 10 || rest === 11) rest = 0;
//   return rest === parseInt(cleaned[10]);
// }

// function validarTitulo(titulo: string): boolean {
//   const cleaned = titulo.replace(/\D/g, "");
//   return cleaned.length >= 10 && cleaned.length <= 12;
// }

// function formatContato(value: string): string {
//   const cleaned = value.replace(/\D/g, "");
//   if (cleaned.length <= 2) return cleaned;
//   if (cleaned.length <= 6) return `(${cleaned.slice(0, 2)}) ${cleaned.slice(2)}`;
//   if (cleaned.length <= 10) return `(${cleaned.slice(0, 2)}) ${cleaned.slice(2, 6)}-${cleaned.slice(6)}`;
//   return `(${cleaned.slice(0, 2)}) ${cleaned.slice(2, 7)}-${cleaned.slice(7, 11)}`;
// }

// function getApiBaseUrl() {
//   const base = import.meta.env.VITE_API_URL || "/api";

//   if (/^https?:\/\//i.test(base)) {
//     return base.replace(/\/api\/?$/, "");
//   }

//   return window.location.origin;
// }

// function getImageUrl(imagePath?: string) {
//   if (!imagePath) return "";
//   if (/^https?:\/\//i.test(imagePath)) return imagePath;
//   return `${getApiBaseUrl()}${imagePath.startsWith("/") ? "" : "/"}${imagePath}`;
// }

// export default function FormModal({ isOpen, onClose, onSave, initialData }: Props) {
//   const toast = useToast();
//   const videoRef = useRef<HTMLVideoElement | null>(null);
//   const streamRef = useRef<MediaStream | null>(null);

//   const [loading, setLoading] = useState(false);
//   const [submitted, setSubmitted] = useState(false);
//   const [touched, setTouched] = useState<Record<string, boolean>>({});
//   const [previewUrl, setPreviewUrl] = useState("");
//   const [imageFile, setImageFile] = useState<File | null>(null);
//   const [cameraOpen, setCameraOpen] = useState(false);
//   const [cameraError, setCameraError] = useState("");

//   const [form, setForm] = useState<any>(initialForm);
//   const [liderancas, setLiderancas] = useState<any[]>([]);
//   const [zonas, setZonas] = useState<any[]>([]);
//   const [sessoes, setSessoes] = useState<any[]>([]);

//   function resetAll() {
//     setForm(initialForm);
//     setSubmitted(false);
//     setTouched({});
//     setSessoes([]);
//     setImageFile(null);
//     setCameraError("");
//     setCameraOpen(false);
//     if (previewUrl.startsWith("blob:")) {
//       URL.revokeObjectURL(previewUrl);
//     }
//     setPreviewUrl("");
//   }

//   function handleClose() {
//     resetAll();
//     onClose();
//   }

//   // Combos
//   useEffect(() => {
//     async function loadCombos() {
//       const [l, z] = await Promise.all([LiderancaService.findAll(), ZonaService.findAll()]);
//       setLiderancas(Array.isArray(l) ? l : []);
//       setZonas(Array.isArray(z) ? z : []);
//     }
//     loadCombos();
//   }, []);

//   // Load edit data
//   useEffect(() => {
//     async function loadEditData() {
//       if (!isOpen) return;
//       if (initialData) {
//         setForm({
//           ...initialForm,
//           ...initialData,
//           ano: String(initialData.ano ?? initialForm.ano)
//         });
//         setPreviewUrl(getImageUrl(initialData.image_path || initialData.path || ""));
//         setImageFile(null);
//         if (initialData.zona_id) {
//           const data = await SessaoService.findByZona(Number(initialData.zona_id));
//           setSessoes(data);
//         }
//       } else {
//         resetAll();
//       }
//     }
//     loadEditData();
//   }, [isOpen, initialData]);

//   useEffect(() => {
//     if (!cameraOpen) {
//       streamRef.current?.getTracks().forEach((track) => track.stop());
//       streamRef.current = null;
//       return;
//     }

//     async function startCamera() {
//       try {
//         const stream = await navigator.mediaDevices.getUserMedia({ video: true, audio: false });
//         streamRef.current = stream;

//         if (videoRef.current) {
//           videoRef.current.srcObject = stream;
//           await videoRef.current.play();
//         }
//       } catch {
//         setCameraError("Não foi possível abrir a webcam neste navegador.");
//       }
//     }

//     startCamera();
//   }, [cameraOpen]);

//   function markTouched(field: string) {
//     setTouched(prev => ({ ...prev, [field]: true }));
//   }

//   function isInvalid(field: string) {
//     return (submitted || touched[field]) && !form[field];
//   }

//   async function handleZonaChange(zonaId: string) {
//     setForm({ ...form, zona_id: zonaId, sessao_id: "" });
//     if (!zonaId) return setSessoes([]);
//     const data = await SessaoService.findByZona(Number(zonaId));
//     setSessoes(data);
//   }

//   async function buscarCEP(cep: string) {
//     const cleaned = cep.replace(/\D/g, "");
//     setForm({ ...form, cep: formatCEP(cep) });
//     if (cleaned.length !== 8) return;

//     try {
//       const { data } = await axios.get(`https://viacep.com.br/ws/${cleaned}/json/`);
//       if (data.erro) return;
//       setForm((old: any) => ({
//         ...old,
//         endereco: data.logradouro || "",
//         bairro: data.bairro || "",
//         cidade: data.localidade || "",
//         uf: data.uf || "",
//       }));
//     } catch {
//       toast({ title: "Erro ao buscar CEP", status: "error" });
//     }
//   }

//   async function handleImageChange(file?: File | null) {
//     if (!file) return;

//     if (previewUrl.startsWith("blob:")) {
//       URL.revokeObjectURL(previewUrl);
//     }

//     setImageFile(file);
//     setPreviewUrl(URL.createObjectURL(file));
//   }

//   async function captureFromCamera() {
//     const video = videoRef.current;
//     if (!video) return;

//     const canvas = document.createElement("canvas");
//     canvas.width = video.videoWidth;
//     canvas.height = video.videoHeight;

//     const context = canvas.getContext("2d");
//     if (!context) return;

//     context.drawImage(video, 0, 0, canvas.width, canvas.height);

//     const blob = await new Promise<Blob | null>((resolve) => canvas.toBlob(resolve, "image/jpeg", 0.92));
//     if (!blob) return;

//     const file = new File([blob], `foto-${Date.now()}.jpg`, { type: "image/jpeg" });
//     await handleImageChange(file);
//     setCameraOpen(false);
//   }

//   async function handleSave() {
//     setSubmitted(true);

//     const required = [
//       "nome", "titulo", "ano", "lideranca_id", "zona_id", "sessao_id",
//       "cep", "endereco", "numero", "bairro", "cidade", "uf", "contato", "data_nascimento"
//     ];

//     if (required.some(f => !form[f])) {
//       toast({ title: "Preencha todos os campos obrigatórios", status: "error" });
//       return;
//     }

//     if (form.cpf && !validarCPF(form.cpf)) {
//       toast({ title: "CPF inválido", status: "error" });
//       return;
//     }

//     if (!validarTitulo(form.titulo)) {
//       toast({ title: "Título eleitoral deve ter entre 10 e 12 dígitos", status: "error" });
//       return;
//     }

//     setLoading(true);

//     try {
//       const saved = await onSave({ ...form, image_path: form.image_path || "", imageFile }, imageFile);

//       if (saved) {
//         resetAll();
//         onClose();
//       }
//     } finally {
//       setLoading(false);
//     }
//   }

//   return (
//     <Modal isOpen={isOpen} onClose={handleClose} size="6xl" closeOnOverlayClick>
//       <ModalOverlay />
//       <ModalContent bg="#F7FAFC">
//         <ModalHeader>{initialData ? "Editar Ficha" : "Nova Ficha"}</ModalHeader>

//         <ModalBody>
//           <VStack spacing={4} align="stretch">
//             <Section title="Liderança">
//               <Select
//                 value={form.lideranca_id}
//                 onChange={(e) => setForm({ ...form, lideranca_id: e.target.value })}
//                 borderColor={isInvalid("lideranca_id") ? "red.400" : "gray.200"}
//               >
//                 <option value="">Selecione liderança *</option>
//                 {(Array.isArray(liderancas) ? liderancas : []).map((l) => (
//                   <option key={l.id} value={l.id}>
//                     {l.numero_lideranca} - {l.nome}
//                   </option>
//                 ))}
//               </Select>
//             </Section>

//             <Section title="Foto da ficha">
//               <VStack spacing={4} align="stretch">
//                 <HStack align="start" spacing={4} flexWrap="wrap">
//                   <Box
//                     w={{ base: "100%", md: "280px" }}
//                     border="1px dashed"
//                     borderColor="gray.300"
//                     borderRadius="16px"
//                     overflow="hidden"
//                     bg="gray.50"
//                   >
//                     <AspectRatio ratio={1}>
//                       {previewUrl ? (
//                         <Image src={previewUrl} alt="Pré-visualização da foto" objectFit="cover" />
//                       ) : (
//                         <Flex align="center" justify="center" direction="column" color="gray.500" gap={2}>
//                           <FiImage size={34} />
//                           <Text fontSize="sm">Nenhuma imagem selecionada</Text>
//                         </Flex>
//                       )}
//                     </AspectRatio>
//                   </Box>

//                   <VStack align="stretch" spacing={3} flex="1">
//                     <Text fontSize="sm" color="gray.600">
//                       Adicione uma imagem da ficha ou use a webcam para capturar a foto no momento do cadastro.
//                     </Text>

//                     <HStack flexWrap="wrap">
//                       <Button as="label" htmlFor="ficha-image-input" leftIcon={<FiUpload />} colorScheme="blue" variant="outline">
//                         Selecionar imagem
//                       </Button>

//                       <Input
//                         id="ficha-image-input"
//                         type="file"
//                         accept="image/*"
//                         display="none"
//                         onChange={(e) => handleImageChange(e.target.files?.[0] || null)}
//                       />

//                       <Button
//                         leftIcon={<FiCamera />}
//                         colorScheme="teal"
//                         variant="outline"
//                         onClick={() => {
//                           setCameraError("");
//                           setCameraOpen((value) => !value);
//                         }}
//                       >
//                         {cameraOpen ? "Fechar webcam" : "Usar webcam"}
//                       </Button>

//                       {previewUrl ? (
//                         <Button
//                           leftIcon={<FiX />}
//                           variant="ghost"
//                           colorScheme="red"
//                           onClick={() => {
//                             if (previewUrl.startsWith("blob:")) {
//                               URL.revokeObjectURL(previewUrl);
//                             }
//                             setPreviewUrl("");
//                             setImageFile(null);
//                             setForm((old: any) => ({ ...old, image_path: "" }));
//                           }}
//                         >
//                           Remover foto
//                         </Button>
//                       ) : null}
//                     </HStack>

//                     {cameraError ? (
//                       <Badge colorScheme="red" alignSelf="start">{cameraError}</Badge>
//                     ) : null}

//                     {cameraOpen ? (
//                       <Box borderRadius="16px" overflow="hidden" border="1px solid" borderColor="gray.200" bg="black">
//                         <video ref={videoRef} style={{ width: "100%", display: "block" }} playsInline muted />
//                         <HStack p={3} bg="gray.800" justify="space-between">
//                           <Button size="sm" colorScheme="green" onClick={captureFromCamera}>
//                             Capturar foto
//                           </Button>
//                           <Button size="sm" variant="ghost" colorScheme="whiteAlpha" onClick={() => setCameraOpen(false)}>
//                             Cancelar
//                           </Button>
//                         </HStack>
//                       </Box>
//                     ) : null}
//                   </VStack>
//                 </HStack>
//               </VStack>
//             </Section>

//             <Section title="Dados pessoais">
//               <SimpleGrid columns={2} spacing={3}>
//                 <Box>
//                   <Text mb={1} fontSize="sm" fontWeight="600" color="gray.700">Nome *</Text>
//                   <Input
//                     value={form.nome}
//                     onChange={(e) => setForm({ ...form, nome: e.target.value })}
//                     onBlur={() => markTouched("nome")}
//                     borderColor={isInvalid("nome") ? "red.400" : "gray.200"}
//                   />
//                 </Box>

//                 <Box>
//                   <Text mb={1} fontSize="sm" fontWeight="600" color="gray.700">Ano *</Text>
//                   <Select
//                     value={form.ano}
//                     onChange={(e) => setForm({ ...form, ano: e.target.value })}
//                     onBlur={() => markTouched("ano")}
//                     borderColor={isInvalid("ano") ? "red.400" : "gray.200"}
//                   >
//                     <option value="">Selecione o ano *</option>
//                     {Array.from({ length: 15 }, (_, index) => 2026 + index).map((year) => (
//                       <option key={year} value={String(year)}>
//                         {year}
//                       </option>
//                     ))}
//                   </Select>
//                 </Box>

//                 <Box>
//                   <Text mb={1} fontSize="sm" fontWeight="600" color="gray.700">CPF</Text>
//                   <Input
//                     value={form.cpf}
//                     onChange={(e) => setForm({ ...form, cpf: formatCPF(e.target.value) })}
//                     onBlur={() => markTouched("cpf")}
//                     borderColor={form.cpf && !validarCPF(form.cpf) ? "red.400" : "gray.200"}
//                   />
//                 </Box>

//                 <Box>
//                   <Text mb={1} fontSize="sm" fontWeight="600" color="gray.700">RG</Text>
//                   <Input
//                     value={form.rg}
//                     onChange={(e) => setForm({ ...form, rg: e.target.value })}
//                   />
//                 </Box>

//                 <Box>
//                   <Text mb={1} fontSize="sm" fontWeight="600" color="gray.700">Data de nascimento *</Text>
//                   <Input
//                     type="date"
//                     value={form.data_nascimento}
//                     onChange={(e) => setForm({ ...form, data_nascimento: e.target.value })}
//                     onBlur={() => markTouched("data_nascimento")}
//                     borderColor={isInvalid("data_nascimento") ? "red.400" : "gray.200"}
//                   />
//                 </Box>

//                 <Box>
//                   <Text mb={1} fontSize="sm" fontWeight="600" color="gray.700">Contato *</Text>
//                   <Input
//                     placeholder="(00) 00000-0000"
//                     value={form.contato}
//                     onChange={(e) => setForm({ ...form, contato: formatContato(e.target.value) })}
//                     onBlur={() => markTouched("contato")}
//                     borderColor={isInvalid("contato") ? "red.400" : "gray.200"}
//                   />
//                 </Box>

//                 <Box>
//                   <Text mb={1} fontSize="sm" fontWeight="600" color="gray.700">Nome da mãe</Text>
//                   <Input value={form.nome_mae} onChange={(e) => setForm({ ...form, nome_mae: e.target.value })} />
//                 </Box>
//               </SimpleGrid>
//             </Section>

//             <Section title="Estrutura eleitoral">
//               <SimpleGrid columns={3} spacing={3}>
//                 <Select
//                   value={form.zona_id}
//                   onChange={(e) => handleZonaChange(e.target.value)}
//                   borderColor={isInvalid("zona_id") ? "red.400" : "gray.200"}
//                 >
//                   <option value="">Selecione zona *</option>
//                   {zonas.map((z) => (
//                     <option key={z.id} value={z.id}>
//                       {z.numero} - {z.descricao}
//                     </option>
//                   ))}
//                 </Select>

//                 <Select
//                   value={form.sessao_id}
//                   onChange={(e) => setForm({ ...form, sessao_id: e.target.value })}
//                   borderColor={isInvalid("sessao_id") ? "red.400" : "gray.200"}
//                 >
//                   <option value="">Selecione sessão *</option>
//                   {sessoes.map((s) => (
//                     <option key={s.id} value={s.id}>
//                       {s.numero} - {s.descricao}
//                     </option>
//                   ))}
//                 </Select>

//                 <Input
//                   placeholder="Título eleitoral *"
//                   value={form.titulo}
//                   onChange={(e) => setForm({ ...form, titulo: formatTitulo(e.target.value) })}
//                   borderColor={isInvalid("titulo") ? "red.400" : "gray.200"}
//                 />
//               </SimpleGrid>
//             </Section>

//             <Section title="Endereço">
//               <SimpleGrid columns={3} spacing={3}>
//                 <Input
//                   placeholder="CEP *"
//                   value={form.cep}
//                   onChange={(e) => buscarCEP(e.target.value)}
//                   borderColor={isInvalid("cep") ? "red.400" : "gray.200"}
//                 />
//                 <Input
//                   placeholder="Endereço *"
//                   value={form.endereco}
//                   onChange={(e) => setForm({ ...form, endereco: e.target.value })}
//                   borderColor={isInvalid("endereco") ? "red.400" : "gray.200"}
//                 />
//                 <Input
//                   placeholder="Número *"
//                   value={form.numero}
//                   onChange={(e) => setForm({ ...form, numero: e.target.value })}
//                   borderColor={isInvalid("numero") ? "red.400" : "gray.200"}
//                 />
//                 <Input
//                   placeholder="Bairro *"
//                   value={form.bairro}
//                   onChange={(e) => setForm({ ...form, bairro: e.target.value })}
//                   borderColor={isInvalid("bairro") ? "red.400" : "gray.200"}
//                 />
//                 <Input
//                   placeholder="Cidade *"
//                   value={form.cidade}
//                   onChange={(e) => setForm({ ...form, cidade: e.target.value })}
//                   borderColor={isInvalid("cidade") ? "red.400" : "gray.200"}
//                 />
//                 <Input
//                   placeholder="UF *"
//                   value={form.uf}
//                   onChange={(e) => setForm({ ...form, uf: e.target.value })}
//                   borderColor={isInvalid("uf") ? "red.400" : "gray.200"}
//                 />
//               </SimpleGrid>
//             </Section>

//             <Section title="Observação (opcional)">
//               <Textarea
//                 value={form.observacao}
//                 onChange={(e) => setForm({ ...form, observacao: e.target.value })}
//               />
//             </Section>
//           </VStack>
//         </ModalBody>

//         <ModalFooter>
//           <Button mr={3} onClick={handleClose}>
//             Cancelar
//           </Button>
//           <Button colorScheme="blue" onClick={handleSave} isLoading={loading}>
//             Salvar
//           </Button>
//         </ModalFooter>
//       </ModalContent>
//     </Modal>
//   );
// }


import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Select,
  SimpleGrid,
  Textarea,
  VStack,
  Box,
  Text,
  Input,
  useToast,
  Flex,
  HStack,
  Image,
  AspectRatio,
  Badge,
} from "@chakra-ui/react";

import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { FiCamera, FiImage, FiUpload, FiX } from "react-icons/fi";

import { LiderancaService } from "../../services/lideranca.service";
import { ZonaService } from "../../services/zona.service";
import { SessaoService } from "../../services/sessao.service";

import { formatCPF, formatCEP, formatTitulo } from "./utils";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onSave: (data: any, imageFile?: File | null) => Promise<boolean>;
  initialData?: any;
}

const initialForm = {
  nome: "",
  cpf: "",
  rg: "",
  titulo: "",
  ano: "2026",
  data_nascimento: "",
  nome_mae: "",
  contato: "",

  cep: "",
  endereco: "",
  numero: "",
  bairro: "",
  cidade: "",
  uf: "",

  observacao: "",
  image_path: "",

  lideranca_id: "",
  zona_id: "",
  sessao_id: "",
};

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <Box
      bg="white"
      borderRadius="16px"
      border="1px solid"
      borderColor="gray.200"
      overflow="hidden"
      boxShadow="sm"
    >
      <Box px={5} py={3} bg="gray.50" borderBottom="1px solid" borderColor="gray.200">
        <Text fontSize="md" fontWeight="700" color="gray.700">
          {title}
        </Text>
      </Box>
      <Box p={5}>{children}</Box>
    </Box>
  );
}

// Validações
function validarCPF(cpf: string): boolean {
  const cleaned = cpf.replace(/\D/g, "");
  if (cleaned.length !== 11) return false;
  // Algoritmo CPF (simplificado)
  let sum = 0, rest;
  for (let i = 1; i <= 9; i++) sum += parseInt(cleaned[i - 1]) * (11 - i);
  rest = (sum * 10) % 11;
  if (rest === 10 || rest === 11) rest = 0;
  if (rest !== parseInt(cleaned[9])) return false;

  sum = 0;
  for (let i = 1; i <= 10; i++) sum += parseInt(cleaned[i - 1]) * (12 - i);
  rest = (sum * 10) % 11;
  if (rest === 10 || rest === 11) rest = 0;
  return rest === parseInt(cleaned[10]);
}

function validarTitulo(titulo: string): boolean {
  const cleaned = titulo.replace(/\D/g, "");
  return cleaned.length >= 10 && cleaned.length <= 12;
}

function formatContato(value: string): string {
  const cleaned = value.replace(/\D/g, "");
  if (cleaned.length <= 2) return cleaned;
  if (cleaned.length <= 6) return `(${cleaned.slice(0, 2)}) ${cleaned.slice(2)}`;
  if (cleaned.length <= 10) return `(${cleaned.slice(0, 2)}) ${cleaned.slice(2, 6)}-${cleaned.slice(6)}`;
  return `(${cleaned.slice(0, 2)}) ${cleaned.slice(2, 7)}-${cleaned.slice(7, 11)}`;
}

function getApiBaseUrl() {
  const base = import.meta.env.VITE_API_URL || "/api";

  if (/^https?:\/\//i.test(base)) {
    return base.replace(/\/api\/?$/, "");
  }

  return window.location.origin;
}

function getImageUrl(imagePath?: string) {
  if (!imagePath) return "";
  if (/^https?:\/\//i.test(imagePath)) return imagePath;
  return `${getApiBaseUrl()}${imagePath.startsWith("/") ? "" : "/"}${imagePath}`;
}

export default function FormModal({ isOpen, onClose, onSave, initialData }: Props) {
  const toast = useToast();
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const streamRef = useRef<MediaStream | null>(null);

  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [touched, setTouched] = useState<Record<string, boolean>>({});
  const [previewUrl, setPreviewUrl] = useState("");
  const [imageFile, setImageFile] = useState<File | null>(null);
  const [cameraOpen, setCameraOpen] = useState(false);
  const [cameraError, setCameraError] = useState("");

  const [form, setForm] = useState<any>(initialForm);
  const [liderancas, setLiderancas] = useState<any[]>([]);
  const [zonas, setZonas] = useState<any[]>([]);
  const [sessoes, setSessoes] = useState<any[]>([]);

  function resetAll() {
    setForm(initialForm);
    setSubmitted(false);
    setTouched({});
    setSessoes([]);
    setImageFile(null);
    setCameraError("");
    setCameraOpen(false);
    if (previewUrl.startsWith("blob:")) {
      URL.revokeObjectURL(previewUrl);
    }
    setPreviewUrl("");
  }

  function handleClose() {
    resetAll();
    onClose();
  }

  // Combos
  useEffect(() => {
    async function loadCombos() {
      const [l, z] = await Promise.all([LiderancaService.findAll(), ZonaService.findAll()]);
      setLiderancas(Array.isArray(l) ? l : []);
      setZonas(Array.isArray(z) ? z : []);
    }
    loadCombos();
  }, []);

  // Load edit data
  useEffect(() => {
    async function loadEditData() {
      if (!isOpen) return;
      if (initialData) {
        setForm({
          ...initialForm,
          ...initialData,
          ano: String(initialData.ano ?? initialForm.ano)
        });
        setPreviewUrl(getImageUrl(initialData.image_path || initialData.path || ""));
        setImageFile(null);
        if (initialData.zona_id) {
          const data = await SessaoService.findByZona(Number(initialData.zona_id));
          setSessoes(data);
        }
      } else {
        resetAll();
      }
    }
    loadEditData();
  }, [isOpen, initialData]);

  useEffect(() => {
    if (!cameraOpen) {
      streamRef.current?.getTracks().forEach((track) => track.stop());
      streamRef.current = null;
      return;
    }

    async function startCamera() {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ video: true, audio: false });
        streamRef.current = stream;

        if (videoRef.current) {
          videoRef.current.srcObject = stream;
          await videoRef.current.play();
        }
      } catch {
        setCameraError("Não foi possível abrir a webcam neste navegador.");
      }
    }

    startCamera();
  }, [cameraOpen]);

  function markTouched(field: string) {
    setTouched(prev => ({ ...prev, [field]: true }));
  }

  function isInvalid(field: string) {
    return (submitted || touched[field]) && !form[field];
  }

  async function handleZonaChange(zonaId: string) {
    setForm({ ...form, zona_id: zonaId, sessao_id: "" });
    if (!zonaId) return setSessoes([]);
    const data = await SessaoService.findByZona(Number(zonaId));
    setSessoes(data);
  }

  async function buscarCEP(cep: string) {
    const cleaned = cep.replace(/\D/g, "");
    setForm({ ...form, cep: formatCEP(cep) });
    if (cleaned.length !== 8) return;

    try {
      const { data } = await axios.get(`https://viacep.com.br/ws/${cleaned}/json/`);
      if (data.erro) return;
      setForm((old: any) => ({
        ...old,
        endereco: data.logradouro || "",
        bairro: data.bairro || "",
        cidade: data.localidade || "",
        uf: data.uf || "",
      }));
    } catch {
      toast({ title: "Erro ao buscar CEP", status: "error" });
    }
  }

  async function handleImageChange(file?: File | null) {
    if (!file) return;

    if (previewUrl.startsWith("blob:")) {
      URL.revokeObjectURL(previewUrl);
    }

    setImageFile(file);
    setPreviewUrl(URL.createObjectURL(file));
  }

  async function captureFromCamera() {
    const video = videoRef.current;
    if (!video) return;

    const canvas = document.createElement("canvas");
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;

    const context = canvas.getContext("2d");
    if (!context) return;

    context.drawImage(video, 0, 0, canvas.width, canvas.height);

    const blob = await new Promise<Blob | null>((resolve) => canvas.toBlob(resolve, "image/jpeg", 0.92));
    if (!blob) return;

    const file = new File([blob], `foto-${Date.now()}.jpg`, { type: "image/jpeg" });
    await handleImageChange(file);
    setCameraOpen(false);
  }

  async function handleSave() {
    setSubmitted(true);

    const required = [
      "nome", "titulo", "ano", "lideranca_id", "zona_id", "sessao_id",
      "cep", "endereco", "numero", "bairro", "cidade", "uf", "contato", "data_nascimento"
    ];

    if (required.some(f => !form[f])) {
      toast({ title: "Preencha todos os campos obrigatórios", status: "error" });
      return;
    }

    if (form.cpf && !validarCPF(form.cpf)) {
      toast({ title: "CPF inválido", status: "error" });
      return;
    }

    if (!validarTitulo(form.titulo)) {
      toast({ title: "Título eleitoral deve ter entre 10 e 12 dígitos", status: "error" });
      return;
    }

    setLoading(true);

    try {
      const saved = await onSave({ ...form, image_path: form.image_path || "", imageFile }, imageFile);

      if (saved) {
        resetAll();
        onClose();
      }
    } finally {
      setLoading(false);
    }
  }

  return (
    <Modal isOpen={isOpen} onClose={handleClose} size="6xl" closeOnOverlayClick>
      <ModalOverlay />
      <ModalContent bg="#F7FAFC">
        <ModalHeader>
          <Flex align="center" justify="space-between" gap={3} flexWrap="wrap">
            <Text>{initialData ? "Editar Ficha" : "Nova Ficha"}</Text>
            <VStack align="flex-end" spacing={1}>
              <Badge colorScheme={initialData?.status === "inativo" ? "red" : "green"} px={2} py={1} borderRadius="md">
                {initialData?.status === "inativo" ? "STATUS: INATIVO" : "STATUS: ATIVO"}
              </Badge>
              <Text fontSize="xs" fontWeight="normal" color="gray.500">
                {initialData
                  ? "Para alterar o status, use o botão Ativar/Inativar na listagem."
                  : "Esta ficha será cadastrada como ativa."}
              </Text>
            </VStack>
          </Flex>
        </ModalHeader>

        <ModalBody>
          <VStack spacing={4} align="stretch">
            <Section title="Liderança">
              <Select
                value={form.lideranca_id}
                onChange={(e) => setForm({ ...form, lideranca_id: e.target.value })}
                borderColor={isInvalid("lideranca_id") ? "red.400" : "gray.200"}
              >
                <option value="">Selecione liderança *</option>
                {(Array.isArray(liderancas) ? liderancas : []).map((l) => (
                  <option key={l.id} value={l.id}>
                    {l.numero_lideranca} - {l.nome}
                  </option>
                ))}
              </Select>
            </Section>

            <Section title="Foto da ficha">
              <VStack spacing={4} align="stretch">
                <HStack align="start" spacing={4} flexWrap="wrap">
                  <Box
                    w={{ base: "100%", md: "280px" }}
                    border="1px dashed"
                    borderColor="gray.300"
                    borderRadius="16px"
                    overflow="hidden"
                    bg="gray.50"
                  >
                    <AspectRatio ratio={1}>
                      {previewUrl ? (
                        <Image src={previewUrl} alt="Pré-visualização da foto" objectFit="cover" />
                      ) : (
                        <Flex align="center" justify="center" direction="column" color="gray.500" gap={2}>
                          <FiImage size={34} />
                          <Text fontSize="sm">Nenhuma imagem selecionada</Text>
                        </Flex>
                      )}
                    </AspectRatio>
                  </Box>

                  <VStack align="stretch" spacing={3} flex="1">
                    <Text fontSize="sm" color="gray.600">
                      Adicione uma imagem da ficha ou use a webcam para capturar a foto no momento do cadastro.
                    </Text>

                    <HStack flexWrap="wrap">
                      <Button as="label" htmlFor="ficha-image-input" leftIcon={<FiUpload />} colorScheme="blue" variant="outline">
                        Selecionar imagem
                      </Button>

                      <Input
                        id="ficha-image-input"
                        type="file"
                        accept="image/*"
                        display="none"
                        onChange={(e) => handleImageChange(e.target.files?.[0] || null)}
                      />

                      <Button
                        leftIcon={<FiCamera />}
                        colorScheme="teal"
                        variant="outline"
                        onClick={() => {
                          setCameraError("");
                          setCameraOpen((value) => !value);
                        }}
                      >
                        {cameraOpen ? "Fechar webcam" : "Usar webcam"}
                      </Button>

                      {previewUrl ? (
                        <Button
                          leftIcon={<FiX />}
                          variant="ghost"
                          colorScheme="red"
                          onClick={() => {
                            if (previewUrl.startsWith("blob:")) {
                              URL.revokeObjectURL(previewUrl);
                            }
                            setPreviewUrl("");
                            setImageFile(null);
                            setForm((old: any) => ({ ...old, image_path: "" }));
                          }}
                        >
                          Remover foto
                        </Button>
                      ) : null}
                    </HStack>

                    {cameraError ? (
                      <Badge colorScheme="red" alignSelf="start">{cameraError}</Badge>
                    ) : null}

                    {cameraOpen ? (
                      <Box borderRadius="16px" overflow="hidden" border="1px solid" borderColor="gray.200" bg="black">
                        <video ref={videoRef} style={{ width: "100%", display: "block" }} playsInline muted />
                        <HStack p={3} bg="gray.800" justify="space-between">
                          <Button size="sm" colorScheme="green" onClick={captureFromCamera}>
                            Capturar foto
                          </Button>
                          <Button size="sm" variant="ghost" colorScheme="whiteAlpha" onClick={() => setCameraOpen(false)}>
                            Cancelar
                          </Button>
                        </HStack>
                      </Box>
                    ) : null}
                  </VStack>
                </HStack>
              </VStack>
            </Section>

            <Section title="Dados pessoais">
              <SimpleGrid columns={2} spacing={3}>
                <Box>
                  <Text mb={1} fontSize="sm" fontWeight="600" color="gray.700">Nome *</Text>
                  <Input
                    value={form.nome}
                    onChange={(e) => setForm({ ...form, nome: e.target.value })}
                    onBlur={() => markTouched("nome")}
                    borderColor={isInvalid("nome") ? "red.400" : "gray.200"}
                  />
                </Box>

                <Box>
                  <Text mb={1} fontSize="sm" fontWeight="600" color="gray.700">Ano *</Text>
                  <Select
                    value={form.ano}
                    onChange={(e) => setForm({ ...form, ano: e.target.value })}
                    onBlur={() => markTouched("ano")}
                    borderColor={isInvalid("ano") ? "red.400" : "gray.200"}
                  >
                    <option value="">Selecione o ano *</option>
                    {Array.from({ length: 15 }, (_, index) => 2026 + index).map((year) => (
                      <option key={year} value={String(year)}>
                        {year}
                      </option>
                    ))}
                  </Select>
                </Box>

                <Box>
                  <Text mb={1} fontSize="sm" fontWeight="600" color="gray.700">CPF</Text>
                  <Input
                    value={form.cpf}
                    onChange={(e) => setForm({ ...form, cpf: formatCPF(e.target.value) })}
                    onBlur={() => markTouched("cpf")}
                    borderColor={form.cpf && !validarCPF(form.cpf) ? "red.400" : "gray.200"}
                  />
                </Box>

                <Box>
                  <Text mb={1} fontSize="sm" fontWeight="600" color="gray.700">RG</Text>
                  <Input
                    value={form.rg}
                    onChange={(e) => setForm({ ...form, rg: e.target.value })}
                  />
                </Box>

                <Box>
                  <Text mb={1} fontSize="sm" fontWeight="600" color="gray.700">Data de nascimento *</Text>
                  <Input
                    type="date"
                    value={form.data_nascimento}
                    onChange={(e) => setForm({ ...form, data_nascimento: e.target.value })}
                    onBlur={() => markTouched("data_nascimento")}
                    borderColor={isInvalid("data_nascimento") ? "red.400" : "gray.200"}
                  />
                </Box>

                <Box>
                  <Text mb={1} fontSize="sm" fontWeight="600" color="gray.700">Contato *</Text>
                  <Input
                    placeholder="(00) 00000-0000"
                    value={form.contato}
                    onChange={(e) => setForm({ ...form, contato: formatContato(e.target.value) })}
                    onBlur={() => markTouched("contato")}
                    borderColor={isInvalid("contato") ? "red.400" : "gray.200"}
                  />
                </Box>

                <Box>
                  <Text mb={1} fontSize="sm" fontWeight="600" color="gray.700">Nome da mãe</Text>
                  <Input value={form.nome_mae} onChange={(e) => setForm({ ...form, nome_mae: e.target.value })} />
                </Box>
              </SimpleGrid>
            </Section>

            <Section title="Estrutura eleitoral">
              <SimpleGrid columns={3} spacing={3}>
                <Select
                  value={form.zona_id}
                  onChange={(e) => handleZonaChange(e.target.value)}
                  borderColor={isInvalid("zona_id") ? "red.400" : "gray.200"}
                >
                  <option value="">Selecione zona *</option>
                  {zonas.map((z) => (
                    <option key={z.id} value={z.id}>
                      {z.numero} - {z.descricao}
                    </option>
                  ))}
                </Select>

                <Select
                  value={form.sessao_id}
                  onChange={(e) => setForm({ ...form, sessao_id: e.target.value })}
                  borderColor={isInvalid("sessao_id") ? "red.400" : "gray.200"}
                >
                  <option value="">Selecione sessão *</option>
                  {sessoes.map((s) => (
                    <option key={s.id} value={s.id}>
                      {s.numero} - {s.descricao}
                    </option>
                  ))}
                </Select>

                <Input
                  placeholder="Título eleitoral *"
                  value={form.titulo}
                  onChange={(e) => setForm({ ...form, titulo: formatTitulo(e.target.value) })}
                  borderColor={isInvalid("titulo") ? "red.400" : "gray.200"}
                />
              </SimpleGrid>
            </Section>

            <Section title="Endereço">
              <SimpleGrid columns={3} spacing={3}>
                <Input
                  placeholder="CEP *"
                  value={form.cep}
                  onChange={(e) => buscarCEP(e.target.value)}
                  borderColor={isInvalid("cep") ? "red.400" : "gray.200"}
                />
                <Input
                  placeholder="Endereço *"
                  value={form.endereco}
                  onChange={(e) => setForm({ ...form, endereco: e.target.value })}
                  borderColor={isInvalid("endereco") ? "red.400" : "gray.200"}
                />
                <Input
                  placeholder="Número *"
                  value={form.numero}
                  onChange={(e) => setForm({ ...form, numero: e.target.value })}
                  borderColor={isInvalid("numero") ? "red.400" : "gray.200"}
                />
                <Input
                  placeholder="Bairro *"
                  value={form.bairro}
                  onChange={(e) => setForm({ ...form, bairro: e.target.value })}
                  borderColor={isInvalid("bairro") ? "red.400" : "gray.200"}
                />
                <Input
                  placeholder="Cidade *"
                  value={form.cidade}
                  onChange={(e) => setForm({ ...form, cidade: e.target.value })}
                  borderColor={isInvalid("cidade") ? "red.400" : "gray.200"}
                />
                <Input
                  placeholder="UF *"
                  value={form.uf}
                  onChange={(e) => setForm({ ...form, uf: e.target.value })}
                  borderColor={isInvalid("uf") ? "red.400" : "gray.200"}
                />
              </SimpleGrid>
            </Section>

            <Section title="Observação (opcional)">
              <Textarea
                value={form.observacao}
                onChange={(e) => setForm({ ...form, observacao: e.target.value })}
              />
            </Section>
          </VStack>
        </ModalBody>

        <ModalFooter>
          <Button mr={3} onClick={handleClose}>
            Cancelar
          </Button>
          <Button colorScheme="blue" onClick={handleSave} isLoading={loading}>
            Salvar
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}